import './SkillTrackerStatusSpanConfig';
import { useTranslation } from 'react-i18next';

import { ContainerStyled } from './styles/SkillTrackerStatusSpanStyles';
import { StudentSkillStatus } from '../../../cache/learner/kanbanReactiveVar';

import GoalTargetIcon from '../../icons/svg/GoalTargetIcon';
import { skillStatusType } from '../ModalComponent/NewModalLayoutComponent';

interface ISkillTrackerStatusSpanProps {
  status: skillStatusType;
}

const SkillTrackerStatusSpan: React.FC<ISkillTrackerStatusSpanProps> = ({ status }: ISkillTrackerStatusSpanProps) => {
  const { t } = useTranslation('SkillTrackerStatusSpan');
  const text = t('SKILL_TRACKER_TEXT');

  const skillTrackerText = (): string => {
    switch (status) {
      case StudentSkillStatus.TOLEARN:
        return text + ` ${t('BACKLOG_LABEL_TEXT')}`.toLowerCase();

      case StudentSkillStatus.LEARNING:
        return text + ` ${t('LEARNING_LABEL_TEXT')}`.toLowerCase();

      case StudentSkillStatus.COMPLETED:
        return text + ` ${t('COMPLETED_LABEL_TEXT')}`.toLowerCase();

      default:
        return text + ` ${t('BACKLOG_LABEL_TEXT')}`.toLowerCase();
    }
  };

  return (
    <ContainerStyled aria-label="skill status">
      <GoalTargetIcon aria-label="goal target icon" />
      {skillTrackerText()}
    </ContainerStyled>
  );
};

export default SkillTrackerStatusSpan;
